export const PRICE_LEVELS = {
  COMFORT: {
    id: 1,
    type: "Comfort",
    total: 0,
  },
  SUPERIOR: {
    id: 2,
    type: "Superior",
    total: 0,
  },
  LUXURY: {
    id: 3,
    type: "Luxury",
    total: 0,
  },
};

export const PRICE_TYPES = {
  SELLER: {
    id: 1,
    type: "seller",
    label: "SELLER",
  },
  RESELLER: {
    id: 2,
    type: "reseller",
    label: "RESELLER",
  },
};

export const PRICES_ALERT_MESSAGES = {
  MISSING_UPSALES: "Upsales has not been added!",
  PRICE_IS_NEGATIVE: "Level price is negative!",
};
